// cryptoUtils.js

import CryptoJS from 'crypto-js';

export function encryptMessage(message, keyBase64) {
    const key = CryptoJS.enc.Base64.parse(keyBase64);
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(message, key, { iv: iv });
    // Concatenate IV and encrypted message
    const ivCiphertext = iv.concat(encrypted.ciphertext);
    // Base64 encode the result
    return CryptoJS.enc.Base64.stringify(ivCiphertext);
}

export function decryptMessage(encryptedMessageBase64, keyBase64) {
    const key = CryptoJS.enc.Base64.parse(keyBase64);
    const ivCiphertext = CryptoJS.enc.Base64.parse(encryptedMessageBase64);
    // Extract IV and ciphertext
    const iv = CryptoJS.lib.WordArray.create(ivCiphertext.words.slice(0, 4), 16);
    const ciphertext = CryptoJS.lib.WordArray.create(ivCiphertext.words.slice(4), ivCiphertext.sigBytes - 16);
    // Decrypt
    const decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, key, { iv: iv });
    return decrypted.toString(CryptoJS.enc.Utf8);
}
